<!-- 拼团订单列表 -->
<template>
  <div class="my-group-buy">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="60"
          v-if="isData"
          @load="onLoad"
      >
        <div class="card" v-for="(item, index) in groupList" :key="index">
          <MyGroupBuyCard :cardDetail="item"/>
        </div>
      </van-list>
      <EmptyData emptyName="noGroupOrder" v-else/>
      <div class="empty"></div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { reqGetGroupOrderList } from '@/api/personal';
import EmptyData from '@/components/emptyData/emptyData.vue';
import MyGroupBuyCard from '@/pages/personalCenter/myActivity/myGroupBuy/MyGroupBuyCard.vue';

export default {
  data() {
    return {
      add: false,
      orderParam: {
        pageNum: 1,
        pageSize: 20,
      },
      loading: false,
      finished: false,
      refreshing: false, // 下拉刷新
      groupList: [],
      finishTotal: 0,
      isData: true,
    };
  },

  components: {
    EmptyData,
    MyGroupBuyCard,
  },

  computed: {},

  mounted() {
  },

  created() {
    this.getGroupOrderList(this.orderParam);
  },
  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.groupList.length >= this.finishTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.orderParam.pageNum += 1;
        this.getGroupOrderList(this.orderParam);
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      // this.groupList = [];
      this.refreshing = true;
      this.orderParam.pageNum = 1;
      this.getGroupOrderList(this.orderParam);
    },

    // eslint-disable-next-line consistent-return
    async getGroupOrderList(data) {
      this.loading = true;
      const res = await reqGetGroupOrderList(data);
      this.loading = false;
      if (res.code === 0) {
        if (!res.data) {
          this.isData = false;
          this.finished = true;
          return false;
        }
        if (res.data.total === 0) {
          this.isData = false;
        }
        this.finished = this.groupList.length >= res.data.total;
        if (this.refreshing) {
          this.groupList = [];
        }
        setTimeout(() => {
          this.refreshing = false;
          this.loading = false;
          this.groupList.push(...res.data.data);
          this.finishTotal = res.data.total;
        });
      } else {
        this.finished = true;
        this.$toast(`请求异常！${res.msg}`);
      }
    },
    // 进入详情页
    courseDetails(orderNo) {
      this.$sendToApp('goOrderDetail', orderNo);
      this.$router.push({ path: '/indentDetail', query: { orderNo } });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-group-buy {
  .button {
    display: flex;
    justify-content: flex-end;

    .add-address {
      @include commonBtn(132px, 43px, $theme_color, 34px, 22px, $bgWhite);
    }
  }

  .empty{
    width: 100%;
    height: 100px;
  }
}
</style>
